// Pantalla dividida de telemedicina (Rediseño mayor 2026-08-31, Módulo G) —
// ficha del paciente a un lado (la MISMA PatientChartPage completa, vía
// <Outlet/> anidado — no una versión resumida, ver routes.tsx), sala de
// Digital Samba al otro (SalaVideoconsulta.tsx, ya existente desde el Hub de
// formularios). El roomId se resuelve por citaId (useSalaDeCita.ts): si el
// sweep de 1h-antes todavía no corrió, se lo dice al médico en vez de
// fallar en silencio.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { SalaVideoconsulta } from '@/paciente/SalaVideoconsulta';
import { useSalaDeCita } from './useSalaDeCita';

export function TelemedicinaSplitView(): JSX.Element {
  const { t } = useTranslation();
  const { citaId } = useParams() as { citaId: string };
  const sala = useSalaDeCita(citaId);

  return (
    <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
      <div className="min-w-0">
        <Outlet />
      </div>
      <div className="min-w-0 rounded-lg border border-border bg-card p-4">
        {sala.cargando && <div className="h-6 w-6 animate-spin rounded-full border-2 border-hce-pine border-t-transparent" />}
        {!sala.cargando && sala.roomId && <SalaVideoconsulta roomId={sala.roomId} />}
        {!sala.cargando && !sala.roomId && (
          <Alert>
            <AlertDescription>{t('dashboard.salaNoLista')}</AlertDescription>
          </Alert>
        )}
      </div>
    </div>
  );
}
